import axios from 'axios'

const api = axios.create({
  baseURL: '/api/lead'
})

function create (data, onsuccess, onerror) {
  api.post('create', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function saveDriverDetails (data, onsuccess, onerror) {
  api.post('saveDriverDetails', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function saveVehicleDetails (data, onsuccess, onerror) {
  api.post('saveVehicleDetails', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function saveDocument (data, onsuccess, onerror) {
  api.post('saveDocument', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function getCities (data, onsuccess, onerror) {
  api.get('cities', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function getVehicleModels (data, onsuccess, onerror) {
  api.get('vehicleModels', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function getTaxiDispatches (data, onsuccess, onerror) {
  api.get('taxiDispatches', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function getPrivacyInfo (onsuccess, onerror) {
  api.get('privacyInfo')
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function getDocuments (data, onsuccess, onerror) {
  api.get('documents', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function finishOnboarding (onsuccess, onerror) {
  api.post('finishOnboarding')
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

function updateBankAccount (data, onsuccess, onerror) {
  api.post('updateBankAccount', data)
    .then(function (response) {
      onsuccess(response.data)
    })
    .catch((error) => {
      onerror(error)
    })
}

export default {
  create: (data, onsuccess, onerror) => create(data, onsuccess, onerror),
  saveDriverDetails: (data, onsuccess, onerror) => saveDriverDetails(data, onsuccess, onerror),
  saveVehicleDetails: (data, onsuccess, onerror) => saveVehicleDetails(data, onsuccess, onerror),
  saveDocument: (data, onsuccess, onerror) => saveDocument(data, onsuccess, onerror),
  finishOnboarding: (data, onsuccess, onerror) => finishOnboarding(data, onsuccess, onerror),
  getCities: (data, onsuccess, onerror) => getCities(data, onsuccess, onerror),
  getVehicleModels: (data, onsuccess, onerror) => getVehicleModels(data, onsuccess, onerror),
  getTaxiDispatches: (data, onsuccess, onerror) => getTaxiDispatches(data, onsuccess, onerror),
  getDocuments: (data, onsuccess, onerror) => getDocuments(data, onsuccess, onerror),
  getPrivacyInfo: (onsuccess, onerror) => getPrivacyInfo(onsuccess, onerror),
  updateBankAccount: (onsuccess, onerror) => updateBankAccount(onsuccess, onerror)
}
